import { useState } from "react";
import { useLocation } from "react-router-dom";
import * as Dialog from "@radix-ui/react-dialog";
import { Menu, X } from "lucide-react";
import { Sidebar, type NavSection } from "./Sidebar";
import { useEffect } from "react";

/**
 * Hamburger → full-height slide-in sidebar sheet on small screens.
 * Closes automatically on navigation.
 */
export function MobileMenu({
  context,
  sections,
  showBrand = true,
}: {
  context: string;
  sections: NavSection[];
  showBrand?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <button
          aria-label="Open menu"
          className="inline-flex h-11 w-11 items-center justify-center rounded-md text-mute hover:bg-subtle hover:text-ink lg:hidden transition-colors"
        >
          <Menu className="h-5 w-5" />
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm animate-fade-in lg:hidden" />
        <Dialog.Content
          className="fixed left-0 top-0 z-50 h-full w-72 overflow-hidden shadow-2xl animate-slide-in-left lg:hidden"
          aria-describedby={undefined}
        >
          <Dialog.Title className="sr-only">Navigation</Dialog.Title>
          <Sidebar context={context} sections={sections} showBrand={showBrand} className="w-full h-full" />
          {/* Close button overlaid top-right. z-20: Sidebar's own <nav>
              (Sidebar.tsx) is `relative z-10`, but Sidebar's root <aside> has
              no z-index of its own, so it doesn't isolate that into its own
              stacking context - the nav's z-10 escapes and competes directly
              with this button's stacking level. Without an explicit z-index
              higher than 10 here, the nav (explicit z-10) wins over this
              button (implicit z-auto) regardless of DOM order, so taps on
              the visible X were actually landing on the nav underneath it -
              the close icon looked present but did nothing. Also bumped to
              a real 44px touch target (was 32px) and inset with
              safe-area-inset-top so it isn't crowded against a notch/status
              bar on real devices. */}
          <Dialog.Close asChild>
            <button
              aria-label="Close menu"
              className="absolute right-2 z-20 flex h-11 w-11 items-center justify-center rounded-lg transition-colors active:opacity-70"
              style={{ background: "rgba(255,255,255,0.07)", color: "rgba(255,255,255,0.5)", top: "max(0.5rem, env(safe-area-inset-top))" }}
            >
              <X className="h-5 w-5" />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
